import React, { Component } from 'react';
import Typography from '@mui/material/Typography';
import {Link} from "@mui/material";

// Define the AboutContent class component
class AboutContent extends Component {
    render() {
        return (
            <div>
                <Typography paragraph>
                    The Bitcoin CO<sub>2</sub> Emissions Project is funded by <Link href="https://www.yorku.ca/" target="_blank">York University</Link>'s Catalyzing Interdisciplinary
                    Research Clusters initiative and is a part of <Link href="https://www.yorku.ca/research/area/digitalcurrencies/" target="_blank">York University’s Digital Currencies Project</Link>.
                </Typography>
                <Typography paragraph>
                    <Link href="https://andreapodhorsky.com/" target="_blank">Dr. Andrea Podhorsky</Link> from the <Link href="https://www.yorku.ca/laps/econ/" target="_blank">Department of Economics</Link> leads the Bitcoin CO<sub>2</sub> Emissions
                    Project. For any queries, please contact her at <Link href="mailto:andrea@yorku.ca">andrea@yorku.ca</Link>.
                </Typography>
                <Typography paragraph>
                    This website is designed and maintained by <Link href="https://www.linkedin.com/in/amirreza-radjou/" target="_blank">Amirreza Radjou</Link> and <Link href="https://www.linkedin.com/in/vladyslav-nekriach/" target="_blank">Vladyslav Nekriach</Link>.
                </Typography>
            </div>
        );
    }
}

// Define the MethodologyContent class component
class MethodologyContent extends Component {
    render() {
        return (
            <div>
                <Typography variant="h6">Our Methodology</Typography>
                <Typography paragraph>
                    The York University Bitcoin CO<sub>2</sub> Emissions Project employs a detailed methodology to track the energy consumption and CO<sub>2</sub> emissions associated with Bitcoin mining. This includes analyzing mining activity linked to various pools, estimating the geographic distribution of the network's hashrate, and calculating emissions based on regional electricity usage. Our approach ensures 99% coverage of mining pools and leverages real-time data, avoiding excessive extrapolation.
                </Typography>
                <Typography paragraph>
                    The process involves estimating each pool's hashrate, identifying geographic regions of electricity draw, and using stratum server IP addresses for a granular analysis. Key factors such as the efficiency of mining equipment and regional CO<sub>2</sub> emissions factors are integrated into our formulas and calculations to derive accurate estimations of electricity usage and subsequent CO2 emissions.
                </Typography>
                {/* Add more paragraphs or content as needed */}
            </div>
        );
    }
}

// Export these components
export { AboutContent, MethodologyContent };
